import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import PropTypes from 'prop-types';
import IconPriceTag from '@spothero/icons/price-tag';

export const BenefitMessage = ({comparisons, iataCode, ratingInfo}) => {
    const airportPercentLowerPrice = get(
        comparisons,
        'airport_percent_lower_price',
        0
    );
    const {star_rating: starRating} = ratingInfo;
    const showAirportPercentLowerMessage =
        airportPercentLowerPrice >= 40 && starRating > 4;

    if (isEmpty(comparisons) || !showAirportPercentLowerMessage) {
        return null;
    }

    return (
        <div className="BenefitMessage">
            <span className="BenefitMessage-text">
                <IconPriceTag className="BenefitMessage-icon" /> Price is lower
                than {airportPercentLowerPrice}% of {iataCode} spots on SpotHero
            </span>
        </div>
    );
};

BenefitMessage.propTypes = {
    comparisons: PropTypes.object,
    iataCode: PropTypes.string.isRequired,
    ratingInfo: PropTypes.object.isRequired,
};

export default BenefitMessage;
